const hasDecimal = number => {
	return number % 1 !== 0;
};

/**
 * Get the currency symbol corresponding to a currency code following the ISO 4217 standard
 * @params {string} currency code (EUR, USD ....)
 * @returns {string} currency symbol (€, $ ... ), undefined otherwise
 */
export function getCurrencySymbolFromCode(currencyCode) {
	const CURRENCIES = {
		EUR: "€",
		GBP: "£",
	};

	return CURRENCIES[currencyCode];
}

export function formatNumberFromCurrency(value, currencyCode) {
	if (value !== 0 && (!value || isNaN(value))) {
		return "";
	}

	switch (currencyCode) {
		case "GBP":
			return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
		case "EUR":
			return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
		default:
			return value;
	}
}

export function formatFloatFromCurrency(value, currencyCode) {
	if (value !== 0 && (!value || isNaN(value))) {
		return "";
	}

	let valueToFormat;
	if (hasDecimal(value)) {
		valueToFormat = value.toFixed(2);
	} else {
		valueToFormat = value.toString();
	}

	switch (currencyCode) {
		case "GBP": {
			return valueToFormat.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
		}
		case "EUR": {
			const formattedValue = valueToFormat.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
			const amount = formattedValue.replace(/\./, ",");
			return amount;
		}
		default:
			return value;
	}
}
